import React from "react";
import { Box, CardMedia, useMediaQuery } from "@mui/material";
import useResponsive from "@/hooks/useResponsive";

import {
  getImageContainerStyles,
  getImageWrapperStyles,
  imageStyles,
} from "./styles";

interface IProps {
  imageUrl: string;
  title: string;
}

const DescriptionProductImage: React.FC<IProps> = ({ imageUrl, title }) => {
  // Media
  const isSmallMobile = useMediaQuery("(max-width: 374.98px)");
  const isMobile = useResponsive("down", "md");
  const isTablet = useResponsive("between", "md", "lg");
  const isDesktop = useResponsive("between", "lg", "xl");

  return (
    <Box
      sx={getImageContainerStyles(isSmallMobile, isMobile, isTablet, isDesktop)}
    >
      <Box
        sx={getImageWrapperStyles(isSmallMobile, isMobile, isTablet, isDesktop)}
      >
        <CardMedia
          component="img"
          image={imageUrl}
          alt={title}
          sx={imageStyles}
        />
      </Box>
    </Box>
  );
};

export default DescriptionProductImage;
